import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all providers
export const GET_ALL_PROVIDERS_QUERY = gql`
query GetBrandNames($providerId: Int) {
  getBrandNames(providerId: $providerId)
}
`;


export interface GetAllBrandsResponse {
  getBrandNames: string[];
}

// GetAllProviders service class
export class GetAllBrandsService {
  private static instance: GetAllBrandsService;

  private constructor() { }

  public static getInstance(): GetAllBrandsService {
    if (!GetAllBrandsService.instance) {
      GetAllBrandsService.instance = new GetAllBrandsService();
    }
    return GetAllBrandsService.instance;
  }

  // Fetch all providers
  async getAllBrands(providerId?: number): Promise<string[]> {
    try {
      const variables = providerId ? { providerId } : undefined;
      const { data } = await apolloClient.query<GetAllBrandsResponse>({
        query: GET_ALL_PROVIDERS_QUERY,
        variables,
        fetchPolicy: 'network-only',
      });
      return data.getBrandNames;
    } catch (error: any) {
      console.error('Error fetching providers:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const getAllBrandsService = GetAllBrandsService.getInstance();

// Export convenience function
export async function getAllBrands(providerId?: number): Promise<string[]> {
  return getAllBrandsService.getAllBrands(providerId);
}
